module.exports = __webpack_public_path__ + "images/4bdced0d0672b70ef9a4c6f077e739ccf4fde3f5759d27708c40a762b64344ea.svg";